import Card from '@mui/material/Card';
import type { JSX } from 'react';

import DeliveryEstimatesV2 from '~pages/Sales/Orders/NewOrderForm/DeliveryEstimatesV2';

/**
 * Renders delivery estimates. Render-only: this card has NO title of its
 * own — the embedded DeliveryEstimatesV2 owns all of the card's content (no
 * fork; the estimates are pure derivations of watched form fields). The
 * cycleDistance/cycleTime inputs the estimates read are driven by the
 * legacy RouteEstimateEffects, rendered by effects/OrderFormV3Effects.tsx.
 * No watch hooks, no flag reads, no effects in this file.
 */
export function DeliveryEstimatesPanel(): JSX.Element {
  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <DeliveryEstimatesV2 />
    </Card>
  );
}
